<div class="bdo-loading__wrapper" [class.bdo-loading__wrapper--height]="state === LoadingState.LOADING">
  @if (state === LoadingState.LOADING) {
    <bdo-loading></bdo-loading>
  }

  @if (state === LoadingState.ERROR) {
    <bdo-info-box class="bdo-container--single">
      {{ 'general.error.error' | translate }}
    </bdo-info-box>
  }

  @if (showTable && state !== LoadingState.ERROR) {
    <div>
      @if (aggregationOrdering[currentAggregationIndex - 1]) {
        <div class="re-p-15 re-bg-white">
          <bdo-text-icon
            [text]="('general.action.backTo' | translate) + ' ' + aggregations[aggregationOrdering[currentAggregationIndex - 1]].title "
            [iconPosition]="'left'"
            (itemClicked)="getDataPoints( aggregationOrdering[currentAggregationIndex - 1],
                                aggregations[aggregationOrdering[currentAggregationIndex - 1]].drillUp.startDate,
                                aggregations[aggregationOrdering[currentAggregationIndex - 1]].drillUp.endDate)"
          ></bdo-text-icon>
        </div>
        }
        @if (dataPoints?.length > 0) {
          <table class="re-w-full re-hidden md:re-table">
            <thead>
              <tr>
                <th>{{aggregations[aggregationOrdering[currentAggregationIndex]].timeUnitHeadline}}</th>
                <th>{{ 'meterreadings.history.consumptionIn' | translate }} {{ consumptionUnit | unitPretty }}</th>
                @if (hasCosts) {
                  <th>{{ 'billing.plan.grossInEuro' | translate }}</th>
                }
              </tr>
            </thead>
            @if (state !== LoadingState.LOADING) {
              <tbody>
                @for (dataPoint of dataPoints; track dataPoint) {
                  <tr>
                    <td class="bdo-font--monospace">{{dataPoint.endDate | date:aggregations[aggregationOrdering[currentAggregationIndex]].timeUnitFormat}}</td>
                    <td class="bdo-font--monospace">{{dataPoint.consumption}}</td>
                    @if (hasCosts) {
                      <td class="bdo-font--monospace">{{dataPoint.cost | currency : 'EUR'}}</td>
                    }
                  </tr>
                }
              </tbody>
            }
          </table>
        }
        @if (state !== LoadingState.LOADING) {
          <div class="md:re-hidden">
            @for (dataPoint of dataPoints; track dataPoint) {
              <div
                class="bdo-tile table-row__container--mobile space-line">
                <div>
                  <div class="bold">{{aggregations[aggregationOrdering[currentAggregationIndex]].timeUnitHeadline}}</div>
                  {{ dataPoint?.endDate | date:aggregations[aggregationOrdering[currentAggregationIndex]].timeUnitFormat}}
                </div>
                <div>
                  <div class="bold">{{ 'meterreadings.history.consumptionIn' | translate }} {{ consumptionUnit | unitPretty }}</div>
                  <span>{{ dataPoint?.consumption }}</span>
                </div>
                @if (hasCosts) {
                  <div>
                    <div class="bold">{{ 'payment.overview.table.amount' | translate }}</div>
                    <span>{{ dataPoint?.cost | currency : 'EUR' }}</span>
                  </div>
                }
              </div>
            }
          </div>
        }
        @if (dataPoints?.length === 0) {
          <div class="re-mt-15">
            {{ 'general.error.noValues' | translate }}
          </div>
        }
      </div>
    }

    @if (state !== LoadingState.ERROR) {
      <div class="re-bg-white re-py-30 re-px-15" [ngClass]="{'re-hidden': showTable}">
        <h4 class="re-text-center">{{ chartTitle }}</h4>
        @if (isVisibleChartTabs()) {
          <div class="chart-tabs re-m-auto re-relative re-text-center re-mt-30 re-mb-40">
            @if (showEurNonAvailableMessage) {
              <div class="re-absolute re-w-full re-text-xs re-leading-s">
                <div class="re-bg-white re-relative re-m-auto re-border-gray-900 re-p-5 re-pr-15 re-text-left re-z-50 re-border-athens-grey re-border-2 re-w-[250px]">
                  <bdo-svg (click)="showEurNonAvailableMessage = false"
                    class="re-absolute re-top-0 re-right-0 re-p-5"
                    name="icon-close"
                    styling="icon__close"
                  ></bdo-svg>
                  <p class="re-p-0 re-m-0">{{ 'consumptionHistory.diagram.error.noCosts' | translate }}</p>
                </div>
              </div>
            }
            @if (consumptionUnit?.length > 0) {
              <div
                class="re-button re-cursor-pointer re-mr-10" (click)="updateUnit(ChartUnit[consumptionUnit])"
                [ngClass]="selectedUnit === consumptionUnit ? 're-primary' : 're-secondary'"
                title="In {{ consumptionUnit | unitPretty}} ausgeben">{{ this?.consumptionUnit | unitPretty}}
              </div>
            }
            @if (hasCosts && consumptionUnit?.length > 0) {
              <div
                class="re-button re-cursor-pointer" (click)="updateUnit(ChartUnit.EUR)"
                [ngClass]="selectedUnit === ChartUnit.EUR ? 're-primary' : 're-secondary'" title="In Euro ausgeben">
                {{ 'billing.currency' | translate }}
              </div>
            }
            @if (!hasCosts) {
              <div class="re-button re-bg-secondary inactive" (click)="showEurNonAvailableMessage = true"
                title="Die Kosten können auf dieser Ebene nicht angezeigt werden.">
                {{ 'billing.currency' | translate }}
              </div>
            }
          </div>
        }
        @if (state === LoadingState.IDLE) {
          <div class="re-mb-20">
            @if (aggregationOrdering[currentAggregationIndex - 1]) {
              <bdo-text-icon
                [text]="('general.action.backTo' | translate) + ' ' + aggregations[aggregationOrdering[currentAggregationIndex - 1]].title "
                [iconPosition]="'left'"
                (itemClicked)="getDataPoints( aggregationOrdering[currentAggregationIndex - 1],
                                    aggregations[aggregationOrdering[currentAggregationIndex - 1]].drillUp.startDate,
                                    aggregations[aggregationOrdering[currentAggregationIndex - 1]].drillUp.endDate)"
              ></bdo-text-icon>
            }
          </div>
        }
        <div class="re-text-xxs" style="margin-left: 27px;">{{selectedUnit | unitPretty}}</div>
        <div class="chartWrapper bdo-font--monospace">
          <div #customYAxis id="customYAxis">
            <canvas></canvas>
            <div class="scroll-gradient"></div>
          </div>
          <div class="chartAreaWrapper re-relative" #chartAreaWrapper (scroll)="scrollChart()">
            @if (dataPoints?.length === 0 && state !== LoadingState.LOADING) {
              <div class="bdo-centered re-mx-30">
                {{ 'general.error.noValues' | translate }}
              </div>
            }
            <div class="chartAreaInnerWrapper" [style.width.px]="chartDataWidth">
              @if (state === LoadingState.IDLE && !showTable) {
                <canvas baseChart
                  [data]="chartData"
                  [options]=barChartOptions
                  (chartClick)="showTooltip($event)"
                  type="bar">
                </canvas>
              }
            </div>
            <div #tooltip id="tooltip"
              class="re-text-white re-absolute re-top-0 re-left-0 re-block re-bg-mineshaft re-z-50">
              <button
                class="close re-absolute re-right-15 re-top-15 re-flex re-w-22 re-h-22 mx-w-22 re-items-center re-no-underline re-justify-center re-bg-mineshaft"
                [attr.aria-label]="'general.action.close' | translate"
                (click)="closeTooltip()">
                <svg-icon
                  class="re-text-white re-w-22"
                  src="assets/icons/close.svg">
                </svg-icon>
              </button>
              <div class="re-m-15 re-mr-45 re-leading-m re-text-sm">
                <p>{{openTooltip?.title}}</p>
                <p class="re-mb-10">{{selectedUnit === ChartUnit.EUR ? (openTooltip?.cost | currency : 'EUR') : openTooltip?.consumption }}</p>
                @if (openTooltip?.isDrillDownPossible && aggregations[aggregationOrdering[currentAggregationIndex + 1]]) {
                  <a
                    class="whiten"
                    (click)="getDataPoints(aggregationOrdering[currentAggregationIndex + 1], openTooltip?.startDate, openTooltip?.endDate)"><span
                  >Zur {{ aggregations[aggregationOrdering[currentAggregationIndex + 1]].title }}</span>
                  <bdo-svg name="icon-arrow-right" styling="position-right"></bdo-svg>
                </a>
              }
            </div>
            <div #tooltipArrowDown class="arrow-down re-border-t-mineshaft">
              <div class="inner re-border-t-mineshaft"></div>
            </div>
          </div>
        </div>
        <div #chartScrollbar class="re-mb-20 re-flow-root">
          <div class="re-m-auto re-w-full re-md:w-1/4">
            <div class="re-float-left re-cursor-pointer re-group" (click)="scroll(-150)">
              <div [ngClass]="{'re-animate-translate group-hover:-re-translate-x-5 group-focus:-re-translate-x-5 group-hover:re-text-primary' : displayScrollLeft, 're-text-monochrome-medium-light' : !displayScrollLeft}">
                <svg-icon [src]="'assets/icons/arrow-left-long.svg'"></svg-icon>
              </div>
            </div>
            <div class="re-float-right re-cursor-pointer re-group" (click)="scroll(+150)">
              <div [ngClass]="{'re-animate-translate group-hover:re-translate-x-5 group-focus:re-translate-x-5 group-hover:re-text-primary' : displayScrollRight, 're-text-monochrome-medium-light' : !displayScrollRight}">
                <svg-icon [src]="'assets/icons/arrow-right-long.svg'"></svg-icon>
              </div>
            </div>
          </div>
        </div>
        <p class="re-text-xs re-leading-s re-block">{{ 'consumptionHistory.diagram.hintRounded' | translate }}</p>
      </div>
    </div>
  }
</div>
